import Helmet from 'react-helmet'
import connectToStores from 'alt-utils/lib/connectToStores'

import { HelpEmail, Button } from 'components'
import { AnalyticsUtils } from 'utils'
import { PlusActions } from 'actions'
import { PlusStore } from 'stores'
import { APP_NAME } from 'consts'

import { PlusSource } from 'sources'

import './onboardingInstallContainer.scss'

@connectToStores
export default class OnboardingInstallContainer extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired
  }

  static getStores() {
    return [
      PlusStore
    ]
  }

  static getPropsFromStores() {
    return {
      ...PlusStore.getState()
    }
  }

  constructor(props) {
    super(props)

    const key = props.params.key
    this.state = { key, showInstructions: false, postInstallData: false }
  }

  componentWillMount() {
    if (this.state.key === 'seo') {
      PlusActions.install(this.context.currentUser)
    }
  }

  componentWillUpdate(nextProps) {
    if (this.props.params.key !== nextProps.params.key) {
      this.setState({ key: nextProps.params.key })
    }
  }

  requestInstall() {
    PlusActions.requestPlusInstall(this.context.currentUser)

    this.context.router.replace('/install/requested')
  }

  selfInstall() {
    PlusActions.selfInstall()

    this.context.router.replace('/install/self')
  }

  handleToggleInstructions() {
    const newState = !this.state.showInstructions
    this.setState({ showInstructions: newState })

    newState && AnalyticsUtils.installInstructionsViewed("Onboarding")
  }

  handleClickAddAccountUrl() {
    AnalyticsUtils.clickedAddStaffAccountLink()
  }

  instructions() {
    return (
      <div>
        <ol className="list medium-spacing--bottom">
          <li className="list__item">In your theme editor open up Layout &gt; theme.liquid</li>
          <li className="list__item">After the &lt;head&gt; include the snippet by pasting in this code: &#123;% include 'pluginseo' %&#125;</li>
          <li className="list__item">You should comment out the code that currently generates your page titles and meta descriptions to avoid duplicates. It goes something like...</li>
          <li className="list__item">Find the code in theme.liquid or a snippet it uses to generate the &lt;title&gt;</li>
          <li className="list__item">Comment it out by surrounding it with &#123;% comment %&#125; and &#123;% endcomment %&#125;</li>
          <li className="list__item">Do the same for &lt;meta name="description"</li>
        </ol>
        <p>
          Need help? Email us at <HelpEmail />
        </p>
      </div>
    )
  }

  instructionsToggler() {
    return (
      <p className="small-spacing--top body2">
        <a onTouchTap={::this.handleToggleInstructions}>
          { this.state.showInstructions ? "Hide" : "View" } Instructions
        </a>
      </p>
    )
  }

  retrievePostInstallData() {
    setTimeout(() => {
      PlusSource.fetchRaw()
        .then(data => {
          if (!data.needsInstall && data.hasInclude === true) {
            this.context.router.replace('/')
          } else {
            this.setState({postInstallData: 'failed'})
          }
        })
    }, 5000)
  }

  renderInstall() {
    const { installed, isInstalling } = this.props
    const { postInstallData } = this.state

    if (!installed && !isInstalling) return null;
    if (isInstalling) {
      return (
        <div className="onboardingInstall__content">
          <h1 className="large-spacing--bottom">Installing Plug in SEO...</h1>
          <p>
            This will just take a few minutes.
          </p>
          <p className="medium-spacing--top">
            Need help? Email us at <HelpEmail />
          </p>
        </div>
      )
    }

    if (postInstallData == false) {
      setTimeout(() => {
        this.setState({postInstallData: 'retrieving'})
        this.retrievePostInstallData()
      }, 1000)
      return (
        <div className="onboardingInstall__content">
          <h1 className="large-spacing--bottom">Installing Plug in SEO...</h1>
          <p>
            Just a moment...
          </p>
          <p className="medium-spacing--top">
            Need help? Email us at <HelpEmail />
          </p>
        </div>
      )
    }

    if (postInstallData == 'retrieving') {
      return (
        <div className="onboardingInstall__content">
          <h1 className="large-spacing--bottom">Installing Plug in SEO...</h1>
          <p>
            Finalizing your installation...
          </p>
          <p className="medium-spacing--top">
            Need help? Email us at <HelpEmail />
          </p>
        </div>
      )
    }

    return (
      <div className="onboardingInstall__content">
        <h1 className="large-spacing--bottom">Success! Plug in SEO Plus is now installed in your shop</h1>
        <div>
          <p>One last piece of code needs to be added manually.</p>
          { this.state.showInstructions && this.instructions() }
          { this.instructionsToggler() }
          <p className="large-spacing--top">Would you like us to do that for you free of charge?</p>
        </div>
        <div className="large-spacing--top">
          <Button
            label="Yes, install the code for me"
            buttonType="primary"
            onTouchTap={::this.requestInstall}
          />
          <Button
            label="No, I can install it myself"
            buttonType="secondary"
            className="secondary-btn"
            onTouchTap={::this.selfInstall}
          />
        </div>
      </div>
    )
  }

  renderCodeInstall(key) {
    let content
    if (key === 'self') {
      content = (
        <div>
          <h1 className="large-spacing--bottom">Installing Plug in SEO Code</h1>
          {this.instructions()}
        </div>
      )
    } else {
      const add_account_url = `https://${this.context.currentUser.shop}/admin/settings/account/new`

      content = (
        <div>
          <h1 className="large-spacing--bottom">Can you give us access to your shop?</h1>
          <p>To install Plug in SEO we need access to your theme.</p>
          <p className="medium-spacing--top">Please add <a onTouchTap={::this.handleClickAddAccountUrl} href={add_account_url} target="_blank">help@pluginseo.com</a> as a staff member in your Shopify admin.</p>
          <p className="medium-spacing--top">One of our team members will add this last piece of code to your theme and email you.</p>
          <p className="medium-spacing--top">Need any more help? Email us at <HelpEmail/></p>
        </div>
      )
    }

    return (
      <div className="onboardingInstall__content">
        {content}
        <div className="large-spacing--top">
          <Button
            label="Continue and Setup My SEO"
            buttonType="primary"
            onTouchTap={() => this.context.router.replace('/setup/home')}
          />
          <Button
            label="Setup my SEO Later"
            buttonType="secondary"
            className="secondary-btn"
            onTouchTap={() => this.context.router.replace('/plus/manage')}
          />
        </div>
      </div>
    )
  }

  render() {
    const { key } = this.state
    const content = key === 'seo' ? this.renderInstall() : this.renderCodeInstall(key)
    
    return (
      <div className="onboardingInstall">
        <div className="setup-logo-container">
          <img className="setup-brand-symbol" alt="Plug in Useful" src="../../assets/images/brand-symbol.png" />
          <img className="setup-logo" alt={APP_NAME} src="../../assets/images/logo-color.png" />
        </div>
        {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/OnboardingInstallContainer.js